<template>
    <div v-cloak>
        <b-row>
            <b-col>
                Cycle number {{ level }}
            </b-col>
            <b-col>
                Training and assessment proposal (not more than three months) from 
                <enrolment-details-date-component
                    :student="student"
                    :old-value="enrolmentDetails ? enrolmentDetails.Proposal_date_from : ''"
                    field-name="Proposal_date_from"
                    description="Proposal date from"
                    @refreshData="refreshData"
                />
                to
                <enrolment-details-date-component
                    :student="student"
                    :old-value="enrolmentDetails ? enrolmentDetails.Proposal_date_to: ''"
                    field-name="Proposal_date_to"
                    description="Proposal date to"
                    @refreshData="refreshData"
                />
            </b-col>
        </b-row>

        <b-table
            show-empty
            :items="competencies"
            :fields="competency_fields"
            stacked="md"
            striped
        >
            <template
                v-slot:cell(mentor_id)="row"
            >
                <person-responsible-bulk
                    :enrolment-id="Number(row.item.id)"
                    :code="row.item.code"
                    :old-value="row.item.mentor_id"
                    :users="mentors"
                    field-name="mentor_id"
                    description="Mentor, Team Leader..."
                    @refreshData="refreshData"
                />
            </template>


            <template
                v-slot:cell(delivery_type)="row"
            >
                {{ deliveryType(row.item.delivery_type) }}
            </template>

            <template
                v-slot:cell(trainer_id)="row"
            >
                <person-responsible-bulk
                    :enrolment-id="Number(row.item.id)"
                    :code="row.item.code"
                    :old-value="row.item.trainer_id"
                    :users="teachers"
                    field-name="trainer_id"
                    description="Trainer/s"
                    @refreshData="refreshData"
                />
            </template>

            <template
                v-slot:cell(assessment_method)="row"
            >
                2,3,4,& 5
            </template>

            <template
                v-slot:cell(assessor_id)="row"
            >
                <person-responsible-bulk
                    :enrolment-id="Number(row.item.id)"
                    :code="row.item.code"
                    :old-value="row.item.assessor_id"
                    :users="teachers"
                    field-name="assessor_id"
                    description="Assessor/s"
                    @refreshData="refreshData"
                />
            </template>

            <template
                v-slot:cell(proposed_end_date)="row"
            >
                {{ formatDate(row.item.proposed_end_date) }}
            </template>
        </b-table>
        <hr>
        <b-row>
            <b-col cols="9">
                <sup>1</sup>Workplace Based Delivery (WPB) - (training undertaken at the workplace)<br>
                Ensure all apprentices/trainees undertaking workplace based training at AQF levels 3 and above are withdrawn from routine work duties for a minimum of three hours per week, averaged over a four week cycle, for the purpose of undertaking structured
                training/learning activities (pro rata for part time).<br>
                Ensure all apprentices/ trainees undertaking workplace based training at AQF levels 1 and 2 are withdrawn from routine work duties
                for a minimum of 1.5 hours per week, averaged over a two month cycle, for the purpose of undertaking structured training/learning
                activities. This release must occur periodically.<br>
                The employer, apprentice/trainee and RTO must ensure that a log is maintained to record details of the workplace structured
                withdrawal.
            </b-col>
            <b-col>
                <sup>2</sup><b>Assessment Method/s</b><br>
                1. Third Party Report<br>
                2. Question and answer<br>
                3. Demonstration<br>
                4. Written Response<br>
                5. Observation<br>
                6. Other (please specify)<br>
                <br>
                Note: You can select more than one.
            </b-col>
        </b-row>
    </div>
</template>

<script>
import PersonResponsibleBulk from './PersonResponsibleBulk.vue';
import EnrolmentDetailsDateComponent from './EnrolmentDetailsDateComponent.vue';

/* global axios */
/* global Noty */
/* global _ */
export default {
    name: 'LevelPartTwo',
    components: {
        PersonResponsibleBulk,
        EnrolmentDetailsDateComponent,
    },
    props: {
        competencies: {
            type: Array,
            required: true,
        },
        enrolments: {
            type: Array,
            required: true,
        },
        enrolmentDetails: {
            type: Object,
            required: false,
            default: () => {},
        },
        teachers: {
            type: Array,
            required: true,
        },
        mentors: {
            type: Array,
            required: true,
        },
        student: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            competency_fields: [
                { key: 'code', label: 'Unit Code' },
                { key: 'title', label: 'Unit Title' },
                { key: 'mentor_id', label: 'Workplace Mentor, Team Leader,or Supervisor' },
                { key: 'delivery_type', label: 'Delivery RTO/WBD' },
                { key: 'trainer_id', label: 'Trainer/s' },
                { key: 'assessment_method' },
                { key: 'assessor_id', label: 'Assessor/s' },
                { key: 'proposed_end_date' },
            ],
        };
    },
    computed: {
        level() {
            return Number(this.$route.path.split('/')[3].slice(-1));
        },
    },
    watch: {},
    validations: {},
    methods: {
        refreshData() {
            this.$emit('refreshData');
        },
        formatDate(date) {
            if (moment(date).isValid()) {
                return moment(date).format('DD/MM/YYYY');
            }
            return '-';
        },
        deliveryType(type) {
            switch (Number(type)) {
            case 1:
                return 'RTO';
            case 2:
                return 'WBD';
            case 3:
                return 'BOTH';
            default:
                return '';
            }
        },
    },
};
</script>
